export default "__VITE_ASSET__CDV1ltg9__"